import { render, staticRenderFns } from "./RegisterClosed.vue?vue&type=template&id=72a09694&scoped=true"
import script from "./RegisterClosed.vue?vue&type=script&lang=js"
export * from "./RegisterClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a09694",
  null
  
)

export default component.exports